import { ReactElement } from 'react';
import Tooltip from '@app/common/Tooltip/Tooltip';
import Lang from '@lang/en';
import {
  BookOpenIconNew,
  CalendarIconNew,
  EditPenIcon,
  EmailIconNew,
  UserIconNew,
} from '@assets/images';
import { OrderDetailsI } from '@app/healthcheck/order/types';
import {
  CardStyled,
  StyledContent,
  StyledHeader,
  StyledLinkParagraph,
  StyledParagraph,
  WrapHeader,
} from '../styles';
import {
  applyEllipsis,
  dateFriendlyFormat,
  formatUTCStringAsApiTimestamp,
} from '@app/utils';
import Button from '@designSystem/buttons/index';

interface PersonProps {
  data: OrderDetailsI;
  handleEditOpenPersonal: () => void;
}

const PersonalDetails = ({
  data,
  handleEditOpenPersonal,
}: PersonProps): ReactElement => {
  return (
    <CardStyled>
      <WrapHeader>
        <StyledHeader>{Lang.healthCheckDetailsPersonalCard}</StyledHeader>
        <Button
          data-testid="healthcheck-order-edit-personal-button"
          type="tertiary"
          label={Lang.editText}
          icon={<EditPenIcon />}
          onClick={handleEditOpenPersonal}
        />
      </WrapHeader>
      <StyledContent>
        <Tooltip
          textTooltip={Lang.healthCheckOrderPersonalFullNameTool}
          followingTooltip={true}
          position="bottom-start"
          arrow={false}
          theme="testedme_dark"
        >
          <StyledParagraph data-testid="healthcheck-order-details-fullName">
            <UserIconNew />
            {applyEllipsis(`${data.firstName} ${data.lastName}`, 26)}
          </StyledParagraph>
        </Tooltip>
        <Tooltip
          textTooltip={Lang.healthCheckEditOrderBirthdateLabel}
          followingTooltip={true}
          position="bottom-start"
          arrow={false}
          theme="testedme_dark"
        >
          <StyledParagraph data-testid="healthcheck-order-details-birthday">
            <CalendarIconNew />
            {formatUTCStringAsApiTimestamp(data.birthdate, dateFriendlyFormat)}
          </StyledParagraph>
        </Tooltip>
        <Tooltip
          textTooltip={Lang.healthCheckOrderPersonalDocumentsTool}
          followingTooltip={true}
          position="bottom-start"
          arrow={false}
          theme="testedme_dark"
        >
          <StyledParagraph data-testid="healthcheck-order-details-document">
            <BookOpenIconNew />
            {`${Lang.healthCheckOrderPersonalDocumentsLabel} ${data.passportNumber}`}
          </StyledParagraph>
        </Tooltip>
        <Tooltip
          textTooltip={Lang.healthCheckOrderPersonalEmailTool}
          followingTooltip={true}
          position="bottom-start"
          arrow={false}
          theme="testedme_dark"
        >
          <StyledLinkParagraph
            data-testid="healthcheck-order-details-email"
            href={`mailto:${data.email}`}
            rel="noopener noreferrer"
          >
            <EmailIconNew />
            {applyEllipsis(data.email, 23)}
          </StyledLinkParagraph>
        </Tooltip>
      </StyledContent>
    </CardStyled>
  );
};

export default PersonalDetails;
